var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatientIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#208ce1;}.b,.d{fill:none;}.b{stroke:#707070;opacity:0;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1388 -248)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1388 248)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M40.983,4a5.331,5.331,0,1,0,5.329,5.33A5.331,5.331,0,0,0,40.983,4Z",
    transform: "translate(-25.697)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.542,67.03A10.314,10.314,0,0,0,16.227,64H14.346A10.346,10.346,0,0,0,4,74.346a.941.941,0,0,0,.941.941H25.632a.941.941,0,0,0,.941-.941A10.314,10.314,0,0,0,23.542,67.03Z",
    transform: "translate(0 -48.714)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(1388 248)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 31,
    height: 31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 30,
    height: 30
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientIcon);
export default __webpack_public_path__ + "static/media/patient_icon.9bf8f4a8dd167b3affbda3020393332a.svg";
export { ForwardRef as ReactComponent };